import { Component, OnInit, OnDestroy } from '@angular/core';
import { sweetAlert } from '../../../utils/swal';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { StaffService } from 'src/app/service/staff-service/staff.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';

@Component({
  selector: 'app-staff-list',
  templateUrl: './staff-list.component.html',
  styleUrls: ['./staff-list.component.css']
})
export class StaffListComponent implements OnInit {

  staffList = [];
  search;
  imageModalUrl;
  status = "active";
  user;

  constructor(
    private staffService: StaffService,
    private sharedDataService : SharedDataService
  ) {
  }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data
          this.getStaffList();

        }
      });
  }

  getStaffList() {
    let queryParams = {
      cooperate : this.user.cooperate && this.user.cooperate._id ? this.user.cooperate._id : this.user._id
    }
    this.staffService
      .getStaffList(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if(data) {
          this.staffList = data;
        }
    }, err => {
      sweetAlert('Error', err, 'warning', 'OK');
    });
  }

  openImageModal(url) {
    this.imageModalUrl = url;
  }

  
ngOnDestroy(): void {
}

}
